




































































































































import { Component, Vue } from 'vue-property-decorator'
import { EmailRegex } from '../util/PasswordPolicy'
import fetch from 'node-fetch'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

@Component
export default class ForgotPassword extends Vue {
    // existing user
    private email = ''
    private isInvalidEmail = !EmailRegex.test(this.email)
    private sentPasswordReset = false
    private emailRules = [
      (v: string) => EmailRegex.test(v) || 'Invalid email.'
    ]

    private protocol: string = Vue.prototype.$secureCookies ? 'https' : 'http'
    private protocolApi: string = Vue.prototype.$secureApi ? 'https' : 'http'
    // props
    // @Prop({ type: Boolean, required: true }) secureCookies!: boolean

    // methods
    public async requestPasswordReset (): Promise<void> {
      fetch(`${this.protocolApi}://${Vue.prototype.$hostApi}/api/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: this.email
        })
      })
      this.sentPasswordReset = true
    }

    public toggleButton (): void {
      this.isInvalidEmail = !EmailRegex.test(this.email)
    }

    public goHome (): void {
      this.$router.push('/')
    }
}
